export default __webpack_public_path__ + "static/media/intro-family-desktop.b5b43458.png";